import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "header__cart",
  "data-test": "cart-component"
}
const _hoisted_2 = {
  key: 0,
  class: "header__cart-badge"
}
const _hoisted_3 = { class: "header__cart-count" }
const _hoisted_4 = { class: "header__cart-items-grid" }
const _hoisted_5 = {
  key: 0,
  "data-test": "cart-empty",
  class: "header__cart--empty"
}
const _hoisted_6 = {
  class: "header__cart-items",
  "data-test": "cart-items"
}
const _hoisted_7 = {
  key: 0,
  class: "header__cart-items-buttons",
  "data-test": "cart-actions"
}

import { computed, onBeforeUnmount, onMounted } from "vue";
import { useCartStore } from "../store/cart";
import CartItem from "./CartItem.vue";
import CartPayment from "./CartPayment.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartComponent',
  setup(__props) {

/**
 * CartComponent
 *
 * Renders the cart sidebar panel with a list of cart items,
 * total payment summary, and cart controls (clear, close).
 * Also shows a badge with item count on the cart icon.
 * Listens for Escape key to close the panel.
 */
const cartStore = useCartStore();

onMounted(() => {
  window.addEventListener("keydown", handleEscape);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleEscape);
});

const cartQuantity = computed(() => {
  return cartStore.cartQuantity;
});

const cartItems = computed(() => {
  return cartStore.cartItems;
});

const isCartOpen = computed(() => {
  return cartStore.isCartOpen;
});

function toggleCart() {
  cartStore.toggleCart();
}
function closeCart() {
  cartStore.closeCart();
}
function clearCart() {
  cartStore.clearCart();
}
function handleEscape(event: KeyboardEvent) {
  if (event.key === "Escape" && isCartOpen.value === true) {
    closeCart();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header__cart-icon",
      "data-test": "cart-icon",
      onClick: toggleCart
    }, [
      _cache[1] || (_cache[1] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-e4c23dac><path d=\"M8.25 20.25C8.66421 20.25 9 19.9142 9 19.5C9 19.0858 8.66421 18.75 8.25 18.75C7.83579 18.75 7.5 19.0858 7.5 19.5C7.5 19.9142 7.83579 20.25 8.25 20.25Z\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e4c23dac></path><path d=\"M18.75 20.25C19.1642 20.25 19.5 19.9142 19.5 19.5C19.5 19.0858 19.1642 18.75 18.75 18.75C18.3358 18.75 18 19.0858 18 19.5C18 19.9142 18.3358 20.25 18.75 20.25Z\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e4c23dac></path><path d=\"M2.25 3.75H5.25L7.5 16.5H19.5\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e4c23dac></path><path d=\"M7.5 12.5H19.1925C19.2792 12.5001 19.3633 12.4701 19.4304 12.4151C19.4975 12.3601 19.5434 12.2836 19.5605 12.1986L20.9105 5.44859C20.9214 5.39417 20.92 5.338 20.9066 5.28414C20.8931 5.23029 20.8679 5.18009 20.8327 5.13717C20.7975 5.09426 20.7532 5.05969 20.703 5.03597C20.6528 5.01225 20.598 4.99996 20.5425 5H6\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e4c23dac></path></svg>", 1)),
      (cartQuantity.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(cartQuantity.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (isCartOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "data-test": "cart-overlay",
          class: "header__cart-overlay",
          onClick: closeCart
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'header__cart--open',
        { 'header__cart-panel--visible': isCartOpen.value },
      ]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", { class: "header__cart-container" }, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", {
          class: "header__cart-review",
          "data-test": "cart-title"
        }, " Shopping Cart ", -1)),
        _createElementVNode("div", {
          class: "header__cart-close",
          "data-test": "cart-close",
          onClick: closeCart
        }, [...(_cache[2] || (_cache[2] = [
          _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-e4c23dac><g clip-path=\"url(#clip0_812_3152)\" data-v-e4c23dac><path d=\"M8 16L12 12M16 8L11.9992 12M11.9992 12L8 8M12 12L16 16\" stroke=\"black\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-e4c23dac></path><circle cx=\"12\" cy=\"12\" r=\"11.25\" stroke=\"black\" stroke-width=\"1.5\" data-v-e4c23dac></circle></g><defs data-v-e4c23dac><clipPath id=\"clip0_812_3152\" data-v-e4c23dac><rect width=\"24\" height=\"24\" fill=\"white\" data-v-e4c23dac></rect></clipPath></defs></svg>", 1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (cartQuantity.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("p", null, "You currently have no items in cart", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (cartItem) => {
            return (_openBlock(), _createBlock(CartItem, {
              key: cartItem.product.id,
              id: cartItem.product.id,
              title: cartItem.product.title,
              thumbnail: cartItem.product.thumbnail,
              price: cartItem.product.price
            }, null, 8, ["id", "title", "thumbnail", "price"]))
          }), 128))
        ]),
        (cartQuantity.value !== 0)
          ? (_openBlock(), _createBlock(CartPayment, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      (cartQuantity.value !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_base_button, null, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Place Order", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_base_button, {
                "data-test": "clear-cart",
                type: "outline",
                onClick: clearCart
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Clear Cart", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})